import React from "react";

import "./Link.css";

import Arrow from "./arrow/Arrow";

const Link = ({
  primary = false,
  secondary = false,
  link,
  children,
  ariaLabel = "",
}) => {
  const btnClass = primary ? "primary" : secondary ? "secondary" : "tertiary";

  return (
    <a
      tabIndex={0}
      href={link}
      aria-label={ariaLabel}
      className={`Link ${btnClass}`}
    >
      <span className="Link-text">
        {children}
        {secondary && <Arrow />}
      </span>
    </a>
  );
};

export default Link;
